import React, { useState } from "react";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import api from "../../api/axios";
import { useNavigate } from "react-router-dom";
import { CommonInput } from "../../components/common/CommonInput";
import { CommonButton } from "../../components/common/CommonButton";

export function Signup() {
  const navigate = useNavigate();

  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    role: "",
  });

  const [errors, setErrors] = useState({});
  const [termsChecked, setTermsChecked] = useState(false);
  const [serverError, setServerError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
    setServerError("");
  };

  const validate = () => {
    const fieldErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!values.name) fieldErrors.name = "Name is required";
    else if (values.name.length < 3) fieldErrors.name = "Name must be at least 3 characters";

    if (!values.email) fieldErrors.email = "Email is required";
    else if (!emailRegex.test(values.email)) fieldErrors.email = "Invalid email";

    if (!values.password) fieldErrors.password = "Password is required";
    else if (values.password.length < 6) fieldErrors.password = "Password must be at least 6 characters";

    if (!values.confirmPassword) fieldErrors.confirmPassword = "Confirm your password";
    else if (values.password !== values.confirmPassword) fieldErrors.confirmPassword = "Passwords do not match";

    if (!values.role) fieldErrors.role = "Role is required";

    if (!termsChecked) fieldErrors.terms = "You must agree to the terms and policies";

    return fieldErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const fieldErrors = validate();
    if (Object.keys(fieldErrors).length > 0) {
      setErrors(fieldErrors);
      return;
    }

    const payload = {
      name: values.name,
      email: values.email,
      password: values.password,
      role: values.role,
    };

    setIsLoading(true);
    try {
      await api.post("/users/signup", payload);
      navigate("/login");
    } catch (err) {
      console.error(err);
      if (err.response?.status === 409) setErrors({ email: "Email already exists" });
      else setServerError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="surface-100 min-h-screen flex justify-content-center align-items-center"
      style={{ background: "#fff", position: 'relative' }}
    >
      {isLoading && (
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255,255,255,0.8)', zIndex: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <ProgressSpinner />
        </div>
      )}
      <Card
        className="p-4 p-rounded p-shadow-6"
        style={{
          width: "400px",
          borderRadius: "12px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
        }}
      >
        <h2 className="text-center mb-3" style={{ color: "#FA5813FF" }}>
          Signup
        </h2>

        <form onSubmit={handleSubmit} className="p-fluid flex flex-column gap-4">
          {/* Name */}
          <CommonInput
            label="Name"
            type="text"
            name="name"
            value={values.name}
            placeholder="Enter your name"
            onChange={handleChange}
          />
          {errors.name && <small style={{ color: "red" }}>{errors.name}</small>}

          {/* Email */}
          <CommonInput
            label="Email"
            type="email"
            name="email"
            value={values.email}
            placeholder="Enter your email"
            onChange={handleChange}
          />
          {errors.email && <small style={{ color: "red" }}>{errors.email}</small>}

          {/* Password */}
          <CommonInput
            label="Password"
            type="password"
            name="password"
            value={values.password}
            placeholder="Enter your password"
            onChange={handleChange}
          />
          {errors.password && <small style={{ color: "red" }}>{errors.password}</small>}

          {/* Confirm Password */}
          <CommonInput
            label="Confirm Password"
            type="password"
            name="confirmPassword"
            value={values.confirmPassword}
            placeholder="Confirm password"
            onChange={handleChange}
          />
          {errors.confirmPassword && (
            <small style={{ color: "red" }}>{errors.confirmPassword}</small>
          )}

          {/* Role */}
          <div className="w-full">
            <label htmlFor="role" className="block mb-1">
              <strong>Role</strong>
            </label>
            <select
              id="role"
              name="role"
              value={values.role}
              onChange={handleChange}
              className="w-full p-2 border rounded-md"
            >
              <option value="" disabled>
                Select a role
              </option>
              <option value="client">Client</option>
              <option value="admin">Admin</option>
            </select>
            {errors.role && <small style={{ color: "red" }}>{errors.role}</small>}
          </div>

          {/* Terms */}
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={termsChecked}
              onChange={(e) => setTermsChecked(e.target.checked)}
            />
            <label>You agree to our terms and policies</label>
          </div>
          {errors.terms && <small style={{ color: "red" }}>{errors.terms}</small>}

          {/* Server error */}
          {serverError && <small style={{ color: "red" }}>{serverError}</small>}

          <CommonButton type="submit" label="Sign Up" />
        </form>

        <div className="mt-3 text-center">
          <span>Already have an account? </span>
          <span
            onClick={() => navigate("/login")}
            style={{ color: "#FA5813FF", fontWeight: "bold", cursor: "pointer" }}
          >
            Login
          </span>
        </div>
      </Card>
    </div>
  );
}
